import { useEffect, useState } from 'react';
import WillgoLogo from '../WillgoLogo.png';
import BtcLogo from '../Byte_the_Code_logo.jpeg';
import { getClient } from "../helpers/general";
import { registerPriceAlertsUser } from "../services/accountServices";
import CONSTANTS from '../Constants/Constants';
import Type1FooterCard from './Footertypes/Type1FooterCard';
import Type2FooterCard from './Footertypes/Type2FooterCard';
import Type4FooterCard from './Footertypes/Type4FooterCard';

function Footer(props){

    const {
        bookingEngine,
        agentDetails,
    } = props;

    const [ priceAlertForm, setPriceAlertForm ] = useState({
        client: {},
        email: ""
    });

    useEffect(()=>{
        (async function go(){
            let client = await getClient();
            setPriceAlertForm({
                ...priceAlertForm,
                client: client
            });
        })();
    },[])

    const setPriceAlertEmail = (e) => {
        setPriceAlertForm({
            ...priceAlertForm,
            email: e.target.value
        });
    }

    const subscribeForPriceAlerts = async () => {
        if(priceAlertForm.email===""){
            alert("Please enter your email");
            return;
        }
        let res = await registerPriceAlertsUser(priceAlertForm);
        if(res?.status===400){
            alert("You have already subscribed");
            return;
        }
        if(res._id){
            alert("You have subscribed to price alerts");
            setPriceAlertForm({
                ...priceAlertForm,
                email: ""
            });
        }
    }

    const footerType = parseInt(bookingEngine.searchPageFooterCard || 4);
    let _company_name = agentDetails?.company_info?.business_name;
    if(_company_name?.length>15)
        _company_name = (_company_name?.substring(0,8)+"...")

    return (
        <footer>
            {
                footerType===1 &&
                <Type1FooterCard
                    bookingEngine={bookingEngine}
                    agentDetails={agentDetails}
                    _company_name={_company_name}
                    _logo_url={agentDetails?.company_info?.logo_url}
                />
            }
            {
                footerType===2 &&
                <Type2FooterCard
                    bookingEngine={bookingEngine}
                    agentDetails={agentDetails}
                    _company_name={_company_name}
                    _logo_url={agentDetails?.company_info?.logo_url}
                />
            }
            {
                footerType===4 &&
                <Type4FooterCard
                    bookingEngine={bookingEngine}
                    agentDetails={agentDetails}
                    _company_name={_company_name}
                    _logo_url={agentDetails?.company_info?.logo_url}
                />
            }
            {/*<div style={{display: "flex", padding: 10, alignItems: "center", justifyContent: "center"}}>
                <p className="footer-site-logo">
                    <span style={{fontSize: 13, fontWeight: "bolder", marginRight: 5}}>
                        Powered by</span>
                </p>
                <p className="footer-site-logo">
                    <img src={WillgoLogo} style={{marginBottom: -3}}/>
                </p>
                <p style={{fontWeight: "bolder", fontSize: 13, marginLeft: 2, color: "#a80395", textAlign: "center", letterSpacing: 0.5, fontFamily: "Courgette"}}>
                    welldugo.com</p>
            </div>*/}
        </footer>
    );
}

export default Footer; 